import i18n from "locales/i18n";

interface Props {
  date: Date;
  type?: "short" | "long";
  weekday?: "short" | "long";
  withoutTime?: boolean;
  isLocalTimezone?: boolean;
}

function formatDateTime({
  date,
  type,
  weekday,
  withoutTime,
  isLocalTimezone,
}: Props): string {
  const lang = i18n.language;

  if (!date) {
    return i18n.t("errors.no_date");
  }

  const preparedDate = isLocalTimezone ? date : `${date}Z`;
  const jsDate = new Date(preparedDate);

  if (withoutTime) {
    return jsDate.toLocaleString(lang, {
      year: "numeric",
      month: type === "long" ? "short" : "2-digit",
      day: "2-digit",
    });
  }
  return jsDate.toLocaleString(lang, {
    year: "numeric",
    month: type === "long" ? "short" : "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    weekday,
    timeZone: "Europe/Zurich",
  });
}

export default formatDateTime;
